import styled from '@emotion/styled';
import { Css, H5, Responsive } from '../../../ui';
import { zIndex } from '../../../ui/themer/theme/zIndex';
import { useGetWebsiteDetails } from '../../../components/common/navigation/hooks/useSiteSectionDetails';
import Button from '../../../components/common/button/Button';
import { Color } from '../../../styles/Color';

interface ISearchEmptyStateProps {
	updateQuery: (query: string) => void;
}

export const SearchEmptyState = ({ updateQuery }: ISearchEmptyStateProps) => {
	const { currentSiteSection } = useGetWebsiteDetails();
	const popularSearches =
		currentSiteSection.fields.unifiedSearchConfiguration?.fields
			.popularUnifiedSearches ?? [];

	const message = popularSearches.length
		? 'Type any keywords to search or explore popular searches from fellow travelers.'
		: 'Type any keywords to search.';

	return (
		<NoResultsWrapper>
			<BackgroundWatermark src="/content-search-watermark.svg" />
			<Title>What are you looking for?</Title>
			<Message>{message}</Message>
			<ButtonContainer>
				{popularSearches.map((search) => (
					<StyledButton
						key={search}
						buttonType="secondary"
						disableIcon
						onClick={() => updateQuery(search)}
					>
						{search}
					</StyledButton>
				))}
			</ButtonContainer>
		</NoResultsWrapper>
	);
};

const NoResultsWrapper = styled.div`
	flex: 1;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: ${Css.pxToRem(24)};
`;

const Title = styled(H5)`
	line-height: ${Css.pxToRem(24)};
	margin-bottom: ${Css.pxToRem(8)};
	text-align: center;
`;

const Message = styled.p`
	line-height: ${Css.pxToRem(24)};
	color: ${Color.OnSurfaceLight};
	max-width: ${Css.pxToRem(390)};
	text-align: center;
	margin-bottom: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(14)};
		line-height: ${Css.pxToRem(20)};
		max-width: ${Css.pxToRem(330)};
	}
`;

const ButtonContainer = styled.div`
	max-width: ${Css.pxToRem(330)};

	display: flex;
	gap: ${Css.pxToRem(8)};
	flex-wrap: wrap;
	justify-content: center;
`;

const StyledButton = styled(Button)`
	background-color: ${Color.PrimaryBlue1};
	border-radius: ${Css.pxToRem(8)};
	padding: ${Css.pxToRem(8)} ${Css.pxToRem(12)};
`;

const BackgroundWatermark = styled.img`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 90%;
	z-index: ${zIndex.behind};

	max-width: ${Css.pxToRem(391)};
	margin: 0 auto;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: 85%;
	}
`;
